module.exports = ".w-120 {\n  max-width: 120px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/index/index.component.scss
// module id = ./src/app/components/index/index.component.scss
// module chunks = main